export default "__VITE_PUBLIC_ASSET__29b788cf__"